import apiClient from './apiClient';

export const runBopi     = () => apiClient.post('/bopi/run/', {}).then(r => r.data);
export const listProcBopi = (procId)       => apiClient.get(`/proceduri/${procId}/bopi/`).then(r => r.data);
